<template>
    <div class="main-container">
        <my-header></my-header>
        <div class="container" style="padding-top: 10px;">
            <h1 style="text-align: center;font-size: 22px;">{{extWFlowForm.bidItemName}}</h1>
            <section class="small-container" style="position:relative;padding-top: 20px;">
                <div style="position:absolute;top: 10px;right: 0;"  v-if="!hidden">
                        <el-button size="mini" type="primary" @click="submit">发送</el-button>
                        <el-button size="mini" type="primary"
                                @click="handleAddFile('questionFiles')">上传
                        </el-button>
                </div>
                <div style="display: inline-flex;width: 100%;align-items:center;">
                    <h3 class="iconfont iconxiala" style="width: 85%">质疑文件（<span style="font-size: 12px;font-weight: normal"> 质疑截至时间：{{questionsEndTime}}</span>）</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div style="margin-left: 20px;margin-bottom: 20px;">
                    <el-table :data="questionFiles"
                         :header-cell-style="$root.tableHeaderStyle"
                        :cell-style="$root.tableCellStyle"
                        tooltip-effect="light"
                        size="mini"
                        style="width: 100%"
                        >
                        <el-table-column label="质疑文件" show-overflow-tooltip prop="attachName">
                            <template slot-scope="scope">
                                <a class="words" href="javascript:;"
                                   @click="$root.downloadFileByPath(scope.row.attachPath,scope.row.attachName)"
                                   title="点击下载">
                                    {{ scope.row.attachName}}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column label="文件大小" show-overflow-tooltip prop="attachSize"></el-table-column>
                        <el-table-column label="质疑时间" show-overflow-tooltip prop="createDate"></el-table-column>
                        <el-table-column label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button v-if="!scope.row.id" type="text" size="mini" @click="fileListHandleRemove(scope.row, scope.$index)">删除
                                </el-button>
                                <el-button type="text" size="mini" @click="preview(scope.row)">预览
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>

            <!--答疑及补充文件-->
            <section class="small-container">
                <div style="display: inline-flex;width: 100%">
                    <h3 class="iconfont iconxiala" style="width: 85%">答疑及补充文件</h3>
                </div>

                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div style="margin-left: 20px;">
                    <el-table :data="answeredFiles"
                         :header-cell-style="$root.tableHeaderStyle"
                        :cell-style="$root.tableCellStyle"
                        tooltip-effect="light"
                        size="mini"
                        style="width: 100%"
                        >
                        <el-table-column label="答疑及补充附件" show-overflow-tooltip prop="attachName">
                            <template slot-scope="scope">
                                <a class="words" href="javascript:;"
                                   @click="$root.downloadFileByPath(scope.row.attachPath,scope.row.attachName)"
                                   title="点击下载">
                                    {{ scope.row.attachName}}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column label="文件大小" show-overflow-tooltip prop="attachSize"></el-table-column>
                        <el-table-column label="答疑及补充时间" show-overflow-tooltip prop="createDate"></el-table-column>
                        <el-table-column label="答疑说明" show-overflow-tooltip prop="remarks"></el-table-column>
                        <el-table-column label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" @click="$root.downloadFileByPath(scope.row.attachPath,scope.row.attachName)">下载
                                </el-button>
                                <el-button type="text" size="mini" @click="preview(scope.row)">预览
                                </el-button>
                                <!-- &nbsp;&nbsp;<a href="javascript:;"  style="color:#0091FF;" @click="preview(val)">预览</a> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>
        </div>
        <!-- <my-footer></my-footer> -->
    </div>
</template>

<script type="text/babel">
import util from '@/util/'
import MyHeader from '../common/Header.vue'
import MyFooter from '../common/Footer.vue'
export default {
    name: "bidReturnLower",
    components: {
        MyHeader, MyFooter
    },
    data() {
        return {
            tableHeaderStyle: Object.assign({}, this.$root.tableHeaderStyle, {'text-align': 'left',}),
            tableCellStyle: Object.assign({}, this.$root.tableCellStyle, {'text-align': 'left',}),
            formLabelWidth: '200px',

            questionFiles: [],
            answeredFiles: [],
            extWFlowForm: {},

            supplierId: window.sessionStorage.getItem('loginId'),
            answersEndTime: '',
            questionsEndTime:'',
        }
    },
    created() {
        this.dealId = this.$route.params.dealId;
        this.getDetail();
        this.getBidInfo();
    },
    computed: {
        hidden(){
            //12 答疑  13 回标
            if (this.extWFlowForm.flowFormStatus != 12){
                return true;
            }

            let endTime = new Date(Date.parse(this.questionsEndTime.replace(/-/g,"/")));

            let curDate = new Date();

            if(endTime < curDate){
                return true;
            }else{
                return false;
            }
        }
    },
    mounted() {
      window.questionObj = this;
    },
    methods: {
        /*上传按钮*/
        handleAddFile(type) {
            window.myAppObj.uploadFileDialog = true;
            window.myAppObj.uploadFileDialogRemark = false;
            window.myAppObj.receiveFiledName = type;
        },
        // 预览
        preview (val) {
            // console.log(val,'预览')
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.sessionStorage.getItem('token')+'&attachmentPath='+val.attachPath+'&attachmentName='+encodeURIComponent(val.attachName))
        },
        /*附件删除*/
        fileListHandleRemove(obj, index) {
            let that = this;
            that.$confirm('此操作将删除该附件, 是否继续?', {
                type: 'warning'
            }).then(() => {
                that.questionFiles.splice(index, 1);
                // that.$root.getFunc('/v1/formflowHS/deleteSAttachment/' + obj.id, function (res) {
                //     that.answerTableData.splice(index, 1);
                //     that.$alert(res.msg || '删除成功', {
                //         type: 'success'
                //     })
                // })
            }).catch(() => {
                /*已取消删除*/
            });
        },
        finishUpload(fileType, fileList, contactForm){
            if(contactForm){
                // contactForm.sAttaches = [...contactForm.secureAttachement, ...contactForm.contractAttachement];
            }else{
                this.mapAttachmentVOs[fileType] = fileList;
            }
        },
        submit(){
            let that = this;
            let uploadFiles = this.questionFiles.filter((item) => {
                return !item.id
            });
            if(uploadFiles && uploadFiles.length == 0){
                that.$confirm('请先上传质疑附件', {
                    type: 'warning'
                }).then(() => {

                }).catch(() => {
                    /*已取消删除*/
                });
                return;
            }
            this.$root.postHttp('/v1/outerformflowHS/answerCommit', {
              dealId: this.$route.params.dealId,
              questionList: uploadFiles,
            }, (res) => {
                that.$alert('保存成功', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    callback: action => {

                    }
                });
                that.$router.go(-1);
           });

            /* this.checkForm().then((res)=>{
                if(Array.isArray(res)){
                    this.save(1, 0, ()=>{
                        that.$router.push('/bid/progress');
                    });
                }else {
                    this.$alert(res,{
                        type: 'warning'
                    });
                }
            }).catch(e=>{
                console.log(e);
            }); */
        },
        getDetail() {
            let that = this;
            this.$root.postHttp('/v1/outerformflowHS/getAnswer', {
              dealId: this.$route.params.dealId
            }, (res) => {
                that.answeredFiles = res.data.data.answerList || [];
                that.questionFiles = res.data.data.questionList || [];
           });
        },
        getBidInfo() {
            let that = this;
            that.$root.postHttp('/v1/outerformflowHS/getWFlowFormList', {dealId: this.$route.params.dealId}, (res) => {
                that.answersEndTime = res.data.data.wflowFormInfo.answersDelayTime || res.data.data.wflowFormInfo.answersEndTime;
                that.questionsEndTime = res.data.data.wflowFormInfo.questionsDelayTime || res.data.data.wflowFormInfo.questionsEndTime;
                that.extWFlowForm = res.data.data.extWFlowForm;
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";
.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 60px;
    margin-bottom: 150px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .el-form-item__error{
        width: 300px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }
    .f14 {
        font-size: 14px !important;
    }
    & .unit {
        width: 100px;
        margin-right: 5px;
    }
    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }
    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }
    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }
    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }
    & h5 {
        padding: 0 30px;
    }
    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }
    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }
    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
      width: 100%;
        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }
    .el-form-item {
        width: 100%;
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }
}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/{
  text-align: left;
  .file-list {
    margin-top: 10px;
  }
  .file-button{
      margin-top:-5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/bid/questions.vue